import React from 'react'
import "./stack.css"

export default function Stacks() {


  return (
     <div >

      <div className='streak-photo'>
        <a
         href="https://github.com/gurjazz18"
         >
          <img
            // align="center"

            
            src=
            "https://github-readme-streak-stats.herokuapp.com/?user=gurjazz18"
            // height="200px"
            // width="100%" 
          />
        </a>
      </div>


 
      <div className="stacklanguage">
        <a href="https://github.com/gurjazz18">  
          <img
           
            id='language'
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=gurjazz18"/>
        </a>


        <a href="https://github.com/gurjazz18">
          <img
            // align="center"
            src="https://github-readme-stats.vercel.app/api?username=Gurjazz18&&count_private=true&show_icons=true"
           
            //stats
          />
        </a>
      </div>

    </div>
  )
}
